export default function() {
  return {
    options: this.feature.values,
    clearable: false,
    searchable: false,
    reduce: featureVal => featureVal.id,
    label: "name",
    getOptionKey: o => o.id,
    class: { 'custom-select': true },
  }
}
